import React from 'react'
import logo from './logo.svg'

function NavBarLogo() {
  return <img src={logo} width="30" height="30" alt="logo" />
}

export default NavBarLogo
